// extracted by mini-css-extract-plugin
module.exports = {"garderobo__layout-center":"ScreenPopular_garderobo__layout-center__Vh7tp","garderobo__page-title-left":"ScreenPopular_garderobo__page-title-left__2FS0u"};